// import ConversationApi from './composition-api/conversations';
// const { makeCurrentConversationAsAbsent, makeCurrentConversationAsActive } = ConversationApi()
/*
window.throttle = (func, limit) => {
    let lastFunc
    let lastRan
    return function () {
        const context = this
        const args = arguments
        if (!lastRan) {
            func.apply(context, args)
            lastRan = Date.now()
        } else {
            clearTimeout(lastFunc)
            lastFunc = setTimeout(function () {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args)
                    lastRan = Date.now()
                }
            }, limit - (Date.now() - lastRan))
        }
    }
} */
import { debounce } from "lodash";

// In-memory cache of video src → intrinsic dimensions.
// Populated by handleGlobalVideoMetadata after loadedmetadata fires.
// No persistence — lives only for the current SPA page lifecycle.
window._videoDimsCache = window._videoDimsCache || new Map();
import { useAppState } from "../Stores/AppState";
import { useConversation } from "../Stores/Conversation";
import { useUserStore } from "../Stores/User";

window.throttle = (callback, time_lapse = 1000) =>
    debounce(callback, time_lapse);

window.logTimeWith = function (message) {
    const dateString = new Date();
    const currentTimeStamp = `${dateString.toLocaleDateString()}-${dateString.getHours()}:${dateString.getMinutes()}:${dateString.getSeconds()}:${dateString.getMilliseconds()}`;

    console.log(message, currentTimeStamp);
};

window.sleepAsync = (milliseconds) =>
    new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
    });

window.sleep = function (milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
};

window.sleepFor = (seconds) =>
    new Promise((res) => {
        setTimeout(res, 1000 * seconds);
    });

window.removeUpdateWarningMessages = () => {
    let updateWarningContainer = document.getElementsByClassName("update-nag");
    if (!updateWarningContainer.length)
        updateWarningContainer = document.getElementsByClassName("notice");
    if (!updateWarningContainer.length)
        updateWarningContainer =
            document.getElementsByClassName("notice-warning");

    // updateWarningContainer.length && updateWarningContainer[0]?.remove();
};

window.randomString = (maxDigits = 18) => {
    const newMaxDigits = maxDigits > 18 ? 18 : maxDigits;
    return Math.random()
        .toLocaleString("en-US", { maximumSignificantDigits: newMaxDigits })
        .split(".")[1];
};

window.replaceLinksWithATags = (text) => {
    return text;

    const newText = text.trim();
    if (newText.startsWith("<iframe")) {
        return newText;
    }

    /* eslint-disable-next-line */
    const urlRegex =
        /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return newText.replace(
        urlRegex,
        (url) =>
            `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`,
    );
};

window.removeEmptyTags = (html, exceptions = null) => {
    // TipTap trailing blank / copied-conversation padding at the end only.
    let result = html.replace(
        /(?:<p\b[^>]*>(?:&nbsp;|\u00a0|\s|<br\s*\/?\s*>)*<\/p>\s*)+$/gim,
        "",
    );

    // Require matching open/close tag names so mismatched pairs like
    // `<br></a>` are never treated as empty tags and stripped.
    // Mid-content empty <p></p> becomes <p>&nbsp;</p> so blank lines survive.
    return result.replace(
        /<([A-Za-z][\w:-]*)\b[^>]*><\/\1>/gim,
        (match, tag_name) => {
            if (tag_name.toLowerCase() === "p") {
                return "<p>&nbsp;</p>";
            }

            if (!exceptions) {
                return "";
            }

            let has_exception = false;

            exceptions.forEach((item) => {
                if (match.toLowerCase().startsWith("<" + item)) {
                    has_exception = true;
                }
            });

            return has_exception ? match : "";
        },
    );
};

window.replacingMessageTags = (html) => {
    if (html.includes("<img")) {
        const imgTags = [];
        let imgIndex = 0;

        const htmlWithPlaceholders = html.replace(/<img[^>]*>/gi, (match) => {
            const placeholder = `__IMG_PLACEHOLDER_${imgIndex}__`;
            imgTags[imgIndex] = match;
            imgIndex++;
            return placeholder;
        });

        const processedHtml = htmlWithPlaceholders.replace(
            /<[^/>][^>]*><\/[^>]+>/gim,
            (match, p1, offset) => {
                let div = document.createElement("div");
                div.innerHTML = match;

                if (match.toLowerCase().startsWith("<file")) {
                    const tag_node = div.firstChild;
                    const dom = window.convertHTMLFIleTag({
                        attrs: {
                            fileName: tag_node.attributes?.fileName?.value,
                            fileSize: tag_node.attributes?.fileSize?.value,
                            fileType: tag_node.attributes?.fileType?.value,
                            src: tag_node.attributes?.src?.value,
                        },
                    });

                    return dom.outerHTML;
                } else if (match.toLowerCase().startsWith("<video")) {
                    const tag_node = div.firstChild;
                    const dom = window.convertHTMLVideoTag({
                        attrs: {
                            type: tag_node.attributes?.type?.value,
                            src: tag_node.attributes?.src?.value,
                            width: tag_node.attributes?.width?.value,
                            height: tag_node.attributes?.height?.value,
                            preload: tag_node.attributes?.preload?.value,
                        },
                    });

                    return dom.outerHTML;
                } else {
                    return match;
                }
            },
        );

        let finalHtml = processedHtml;
        imgTags.forEach((imgTag, index) => {
            finalHtml = finalHtml.replace(
                `__IMG_PLACEHOLDER_${index}__`,
                imgTag,
            );
        });

        return finalHtml;
    }

    return html.replace(/<[^/>][^>]*><\/[^>]+>/gim, (match, p1, offset) => {
        let div = document.createElement("div");
        div.innerHTML = match;

        if (match.toLowerCase().startsWith("<file")) {
            const tag_node = div.firstChild;
            const dom = window.convertHTMLFIleTag({
                attrs: {
                    fileName: tag_node.attributes?.fileName?.value,
                    fileSize: tag_node.attributes?.fileSize?.value,
                    fileType: tag_node.attributes?.fileType?.value,
                    src: tag_node.attributes?.src?.value,
                },
            });

            return dom.outerHTML;
        } else if (match.toLowerCase().startsWith("<video")) {
            const tag_node = div.firstChild;
            const dom = window.convertHTMLVideoTag({
                attrs: {
                    type: tag_node.attributes?.type?.value,
                    src: tag_node.attributes?.src?.value,
                    width: tag_node.attributes?.width?.value,
                    height: tag_node.attributes?.height?.value,
                    preload: tag_node.attributes?.preload?.value,
                },
            });

            return dom.outerHTML;
        } else {
            return match; // Return unchanged for other tags
        }
    });
};

window.downloadKaamfuFile = async (event, src, fileName) => {
    event.preventDefault();
    event.stopPropagation();

    const linkEl = event.currentTarget;
    if (linkEl && linkEl.hasAttribute("data-downloading")) {
        return; // Prevent multiple clicks while downloading
    }

    if (linkEl) {
        linkEl.setAttribute("data-downloading", "true");
        linkEl.style.opacity = "0.6";
        linkEl.style.cursor = "wait";
    }


    try {
        const response = await fetch(src);
        if (!response.ok) throw new Error("Network response was not ok");
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName || "download";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error("Download failed, opening in new tab:", error);
        window.open(src, "_blank");
    } finally {
        if (linkEl) {
            linkEl.removeAttribute("data-downloading");
            linkEl.style.opacity = "1";
            linkEl.style.cursor = "pointer";
        }
    }
};

window.convertHTMLFIleTag = (node) => {
    const container = document.createElement("div");
    const link = document.createElement("a");
    const icon = document.createElement("span");
    const span = document.createElement("span");
    const ul = document.createElement("ul");
    const fileName = document.createElement("li");
    const fileSize = document.createElement("li");
    const fileType = document.createElement("li");

    link.href = node.attrs.src;
    link.target = "_blank";

    link.classList.add("file");
    icon.classList.add("icon", "material-symbols-rounded");
    ul.classList.add("file--info");
    icon.append("file_present");

    fileName.append(`Name: ${node.attrs.fileName}`);
    fileSize.append(`Size: ${window.formatBytes(node.attrs.fileSize, 0)}`);
    fileType.append(`Type: ${node.attrs.fileType}`);

    ul.append(fileSize);
    ul.append(fileType);
    ul.append(fileName);

    span.append(ul);
    link.append(icon);
    link.append(span);
    container.append(link);

    const downloadLink = document.createElement("a");
    downloadLink.href = node.attrs.src;
    downloadLink.download = node.attrs.fileName || "";
    downloadLink.target = "_blank";
    downloadLink.textContent = "Download";
    downloadLink.classList.add("d-inline-block", "file-download");
    downloadLink.style.textDecoration = "underline";
    downloadLink.style.cursor = "pointer";

    // Force download using inline onclick because dom.outerHTML strips attached event listeners
    downloadLink.setAttribute("onclick", "window.downloadKaamfuFile(event, this.href, this.download)");

    // Stack download under the file card, aligned with the Name/Size/Type text column.
    // file-css .icon is 64px; -10px icon margin + 10px .file--info padding cancel out.
    container.classList.add("file-attachment");
    container.style.display = "flex";
    container.style.flexDirection = "column";
    container.style.alignItems = "flex-start";
    downloadLink.style.marginLeft = "64px";

    container.append(downloadLink);

    return container;
};

window.convertHTMLVideoTag = (node) => {
    const video = document.createElement("video");
    const source = document.createElement("source");
    source.src = node.attrs.src;
    source.type = checkMKVTypeVideo(node.attrs.type);
    video.controls = true;
    video.preload = node.attrs.preload || "metadata";

    // Use cached pixel dimensions if this video was seen before in this SPA session.
    // The browser derives the correct aspect-ratio immediately — zero layout shift.
    // Falls back to 16:9 CSS on first load; handleGlobalVideoMetadata caches the
    // real dims so every subsequent render uses the exact size.
    const cached = node.attrs.src ? window._videoDimsCache.get(node.attrs.src) : null;
    const width = node.attrs.width || (cached ? cached.w : null);
    const height = node.attrs.height || (cached ? cached.h : null);

    video.style.width = "100%";
    video.style.display = "block";

    if (width && height) {
        video.setAttribute("width", String(width));
        video.setAttribute("height", String(height));
        video.style.aspectRatio = `${width} / ${height}`;
    } else {
        video.style.aspectRatio = "16 / 9";
    }

    video.append(source);

    return video;
};

function checkMKVTypeVideo(type) {
    return !type || type.includes("video/x-matroska") ? "video/mp4" : type;
}


window.formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["b", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

window.stripHtmlTags = (html) => {
    if (!html) return;

    const regex = /(<([^>]+)>)/gi;
    const plainText = html
        .replace(regex, (match, p1, offset) => {
            if (p1.startsWith("<a")) {
                const hrefRegex = /href="([^">]+)"/i;
                const hrefMatch = hrefRegex.exec(p1);
                if (hrefMatch) {
                    return hrefMatch[1] + " ";
                }
            } else if (p1.startsWith("<img")) {
                const srcRegex = /src="([^">]+)"/i;
                const srcMatch = srcRegex.exec(p1);
                if (srcMatch) {
                    return srcMatch[1] + " ";
                }
            }
            return " ";
        })
        .trim();

    return plainText;
};

window.stripHtmlListTags = (html) => {
    const regex =
        /(<(?!\/?(ul|ol|li)\b)[^>]+>|<ul[^>]*>|<\/ul>|<ol[^>]*>|<\/ol>|<li[^>]*>|<\/li>)/gi; // regular expression to match HTML tags
    return html.replace(regex, (match) => {
        if (
            match.toLowerCase().startsWith("<ul") ||
            match.toLowerCase().startsWith("<ol") ||
            match.toLowerCase().startsWith("<li") ||
            match.toLowerCase().startsWith("<p ") ||
            match.toLowerCase().startsWith("<div")
        ) {
            return match.replace(/\s+\S+(['"])\S+(['"])/g, "");
        } else if (
            match.toLowerCase().startsWith("<img") ||
            match.toLowerCase().startsWith("</ul") ||
            match.toLowerCase().startsWith("</ol") ||
            match.toLowerCase().startsWith("</li") ||
            match.toLowerCase().startsWith("</p>") ||
            match.toLowerCase().startsWith("</div") ||
            match.toLowerCase().startsWith("<br") ||
            match.toLowerCase().startsWith("</br") ||
            match.toLowerCase().startsWith("<b") ||
            match.toLowerCase().startsWith("</b") ||
            match.toLowerCase().startsWith("<a") ||
            match.toLowerCase().startsWith("</a") ||
            match.toLowerCase().startsWith("<table") ||
            match.toLowerCase().startsWith("</table") ||
            match.toLowerCase().startsWith("<tr") ||
            match.toLowerCase().startsWith("</tr") ||
            match.toLowerCase().startsWith("<td") ||
            match.toLowerCase().startsWith("</td") ||
            match.toLowerCase().startsWith("<th") ||
            match.toLowerCase().startsWith("</th") ||
            match.toLowerCase().startsWith("<tbody") ||
            match.toLowerCase().startsWith("</tbody") ||
            match.toLowerCase().startsWith("<tfoot") ||
            match.toLowerCase().startsWith("</tfoot") ||
            match.toLowerCase().startsWith("<thead") ||
            match.toLowerCase().startsWith("</thead") ||
            match.toLowerCase().startsWith("<caption") ||
            match.toLowerCase().startsWith("</caption") ||
            match.toLowerCase().startsWith("<colgroup") ||
            match.toLowerCase().startsWith("</colgroup") ||
            match.toLowerCase().startsWith("<col") ||
            match.toLowerCase().startsWith("</col") ||
            match.toLowerCase().startsWith("<rowgroup") ||
            match.toLowerCase().startsWith("</rowgroup") ||
            match.toLowerCase().startsWith("<row") ||
            match.toLowerCase().startsWith("</row") ||
            match.toLowerCase().startsWith("<cell") ||
            match.toLowerCase().startsWith("</cell") ||
            match.toLowerCase().startsWith("<h1") ||
            match.toLowerCase().startsWith("</h1") ||
            match.toLowerCase().startsWith("<h2") ||
            match.toLowerCase().startsWith("</h2") ||
            match.toLowerCase().startsWith("<h3") ||
            match.toLowerCase().startsWith("</h3") ||
            match.toLowerCase().startsWith("<h4") ||
            match.toLowerCase().startsWith("</h4") ||
            match.toLowerCase().startsWith("<h5") ||
            match.toLowerCase().startsWith("</h5") ||
            match.toLowerCase().startsWith("<h6") ||
            match.toLowerCase().startsWith("</h6") ||
            match.toLowerCase().startsWith("<p") ||
            match.toLowerCase().startsWith("</p") ||
            match.toLowerCase().startsWith("</div") ||
            match.toLowerCase().startsWith("<span") ||
            match.toLowerCase().startsWith("</span") ||
            match.toLowerCase().startsWith("<strong") ||
            match.toLowerCase().startsWith("</strong") ||
            match.toLowerCase().startsWith("<em") ||
            match.toLowerCase().startsWith("</em") ||
            match.toLowerCase().startsWith("<i") ||
            match.toLowerCase().startsWith("</i") ||
            match.toLowerCase().startsWith("<u>") ||
            match.toLowerCase().startsWith("</u>") ||
            match.toLowerCase().startsWith("<s>") ||
            match.toLowerCase().startsWith("</s>") ||
            match.toLowerCase().startsWith("<blockquote") ||
            match.toLowerCase().startsWith("</blockquote") ||
            match.toLowerCase().startsWith("<hr") ||
            match.toLowerCase().startsWith("</hr") ||
            match.toLowerCase().startsWith("<code") ||
            match.toLowerCase().startsWith("</code") ||
            match.toLowerCase().startsWith("<pre") ||
            match.toLowerCase().startsWith("</pre") ||
            match.toLowerCase().startsWith("<file") ||
            match.toLowerCase().startsWith("</file") ||
            match.toLowerCase().startsWith("<video") ||
            match.toLowerCase().startsWith("</video") ||
            match.toLowerCase().startsWith("<source") ||
            match.toLowerCase().startsWith("</source")
        ) {
            return match;
        } else return "";
    });
};

// const regex = /(<(?!\/?(ul|ol|li)\b)[^>]+>|<ul[^>]*>|<\/ul>|<ol[^>]*>|<\/ol>|<li[^>]*>|<\/li>)/gi; // regular expression to match HTML tags except for ul, ol, and li
// let strippedText = html.replace(regex, (match) => {
//   if (match.toLowerCase().startsWith('<ul') || match.toLowerCase().startsWith('<ol') || match.toLowerCase().startsWith('<li')) {
//     return match.replace(/\s+\S+(['"])\S+(['"])/g, ''); // remove all attributes from ul, ol, and li tags
//   } else {
//     return '';
//   }
// });

// return strippedText;

window.truncateText = (str, length = 45) => {
    if (!str) return;

    return str.length > length ? str.substring(0, length) + "..." : str;
};

/**
 *
 * this causes links without any http/https/www to append to the current url
 * for ex: glassdoor.co.in/member/profile/stepWelcome.htm -
 * link like this will be appended to location.href
 */

// function validURLRegex(myURL) {
//   return new RegExp('^(https?:\\/\\/)?' // protocol
//         + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' // domain name
//         + '((\\d{1,3}\\.){3}\\d{1,3}))' // ip (v4) address
//         + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port
//         + '(\\?[;&amp;a-z\\d%_.~+=-]*)?' // query string
//         + '(\\#[-a-z\\d_]*)?$', 'i');
// }

window.isArrayEqual = (a, b) => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.

    for (var i = 0; i < a.length; ++i) {
        if (a[i].id !== b[i].id) return false;
    }
    return true;
};

function onFocused() {
    // console.log( "focused ... ");
    window.isAppInActive = false;
    // makeCurrentConversationAsActive();
    useAppState().setInActiveWindow(window.isAppInActive);
    useConversation().updateConnectionStatusIfNotConnected();
}

function onBlurred() {
    // console.log(" blurred ... ");
    window.isAppInActive = true;
    // makeCurrentConversationAsAbsent();
    useAppState().setInActiveWindow(window.isAppInActive);
}

window.addEventListener("focus", onFocused);

// Inactive
window.addEventListener("blur", onBlurred);

document.addEventListener("visibilitychange", () => {
    window.isAppInActive = document.visibilityState === "hidden";
    useAppState().setInActiveWindow(window.isAppInActive);
});

window.timeOutHelper = (call_back, time_in_milli_seconds = 100) => {
    const handler = setTimeout(() => {
        call_back();
        clearTimeout(handler);
    }, time_in_milli_seconds);
};

window.scrollTo = (id) => {
    document.querySelector("#" + id)?.scrollIntoView();
};

window.addEventListener("online", handleOnline);
window.addEventListener("offline", handleOffline);

function handleOnline() {
    console.log("handleOnline");
    setTimeout(() => {
        useUserStore().fetchAndSetUserData();
        useUserStore().fetchUsersProfiles();
    }, 1000);
    useAppState().setInternetConnectivity(true);
}

function handleOffline() {
    useAppState().setInternetConnectivity(false);
}

document.addEventListener("click", handleUserInteraction);

function handleUserInteraction() {
    useAppState().setUserInteraction(true);
    document.removeEventListener("click", handleUserInteraction);
}

window.getMCPToken = async () => {
    const { data } = await axios.get("/mcp-token");
    console.log("access token", data?.data?.access_token);
    return data?.data?.access_token;
};

window.convertBlobToFile = (blob, name) => {
    return new File([blob], name, {
        type: blob.type,
        lastModified: Date.now(),
    });
};
